@if (buttonMode()) {
  <div class="button-upload-container">
    <button
      type="button"
      class="btn-upload"
      [disabled]="isFull"
      (click)="fileInput.click()"
    >
      @if (isFull) {
        Límite alcanzado ({{ maxImages() }})
      } @else {
        + Subir imágenes ({{ previewImages().length }}/{{ maxImages() }})
      }
    </button>
    <input
      type="file"
      #fileInput
      hidden
      multiple
      accept="image/*"
      (change)="onFileSelected($event)"
    />
  </div>

  @if (previewImages().length > 0) {
    <div class="button-mode-grid">
      @for (img of previewImages(); track $index; let i = $index) {
        <div class="button-mode-thumb">
          <img [src]="img.url" alt="Vista previa {{ i + 1 }}" />
          <button
            type="button"
            class="btn-remove-img"
            [attr.aria-label]="'Quitar foto ' + (i + 1)"
            (click)="removeImage(i)"
          >
            ✕
          </button>
        </div>
      }
    </div>
  }
}

@else {
  @if (!isFull) {
    <div
      class="upload-zone"
      [class.dragging]="isDragging()"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)"
    >
      <button type="button" class="upload-trigger" [disabled]="isOptimizing()" (click)="fileInput.click()">
        Añadir fotos (máximo {{ maxImages() }})
      </button>
      <p>También puedes arrastrarlas aquí.</p>
      @if (optimizeForCatalog()) {
        <p class="upload-hint">Se convierten a WebP de máximo 200 KB y 1600 px automáticamente.</p>
      }
      <input
        type="file"
        #fileInput
        hidden
        multiple
        accept="image/*"
        (change)="onFileSelected($event)"
      />
    </div>
  }

  @if (isOptimizing()) {
    <p class="upload-status-message" role="status">Optimizando imágenes...</p>
  }

  @if (errorMessage()) {
    <p class="upload-error-message">{{ errorMessage() }}</p>
  }

  <div class="image-preview-grid">
    @for (img of previewImages(); track $index; let imgIdx = $index) {
      <div class="preview-item">
        <div class="preview-card">
          <img [src]="img.url" alt="Previsualización {{ imgIdx + 1 }}" />


          @if (!simple()) {
            <div class="img-number-wrapper">
              <select
                #positionSelect
                class="img-number-select"
                (change)="onPositionChange(imgIdx, $event)"
                title="Cambiar posición"
                [attr.aria-label]="'Posición de la foto ' + (imgIdx + 1)"
              >
                @for (pos of positionOptions; track pos) {
                  <option [value]="pos" [selected]="pos === imgIdx + 1">
                    {{ pos }}
                  </option>
                }
              </select>
              <span class="img-number-caret">▾</span>
            </div>
          }
          @if (formatFileSize(img); as size) {
            <span class="img-size">{{ size }}</span>
          }
        </div>

          <button
            type="button"
            class="btn-remove-img"
            [attr.aria-label]="'Quitar foto ' + (imgIdx + 1)"
            (click)="removeImage(imgIdx)"
          >
            Quitar foto
          </button>

        @if (!simple() && $index === 0) {
          <span class="img-cover-tag">Imagen de portada</span>
        }
      </div>
    }
  </div>

  @if (!simple() && totalSizeLabel; as total) {
    <p class="total-size">Suma total de todas las imágenes: {{ total }}</p>
  }
}
